import React from 'react';
import styled from 'styled-components';

import SavedLineItemsForm from 'components/forms/SavedLineItemsForm';
import LineItemsForm from 'components/forms/LineItemsForm';
import SubtotalArea from 'components/common/SubtotalArea';
import SalesTaxInput from 'components/inputs/SalesTaxInput';
import DepositSection from './DepositSection';
import FinalPaymentSection from './FinalPaymentSection';
import DiscountSection from './DiscountSection';

const Container = styled.div`
  align-items: center;
  justify-content: flex-start;
  display: flex;
  margin: ${p => p.theme.margin}px;
  margin-top: 20px;
`;

class PricingInfo extends React.PureComponent {
  render() {
    return (
      <div>
        {' '}
        <SavedLineItemsForm
          keys={this.props.keys}
          onChange={this.props.onChange}
          currencySymbol={this.props.currencySymbol}
        />
        <LineItemsForm
          onChange={this.props.onChange}
          currencySymbol={this.props.currencySymbol}
          record={this.props.contract}
          keys={this.props.keys}
        />
        <SubtotalArea record={this.props.contract} currencySymbol={this.props.currencySymbol} />
        <DepositSection
          record={this.props.contract}
          windowWidth={this.props.windowWidth}
          currencySymbol={this.props.currencySymbol}
          onChange={this.props.onChange}
        />
        <Container>
          Total sales tax will be
          <span style={{ padding: 4, position: 'relative' }}>
            <SalesTaxInput
              value={this.props.contract.salesTax && this.props.contract.salesTax}
              onChange={salesTax => {
                this.props.onChange({ salesTax: salesTax || 0 });
              }}
            />
          </span>
        </Container>
        {/* ==== DEPOSIT SECTION =============== */}
        <DiscountSection
          record={this.props.contract}
          currencySymbol={this.props.currencySymbol}
          onChange={this.props.onChange}
        />
        {/* ==== FINAL PAYMENT SECTION =============== */}
        <FinalPaymentSection
          record={this.props.contract}
          currencySymbol={this.props.currencySymbol}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

export default PricingInfo;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/PricingInfo/index.js